export const notificationEnglish = {
  "notification-view-details": "View Details",
  "none-notification-title": "No Notifications Yet",
  "none-notification-description":
    "Looks like there's nothing new for now. Check back later for updates and notifications.",
  "notification-data-redemption-completed-people-message": `Total of {0} credits have been used to redeem {1} contacts.`,
  "notification-services-status-update-message": `Service request status changed to {0}`,
  "notification-receive-referral-credit-bonus-message":
    "{0} referral credits have been added, keep up the good work!",
  "notification-receive-onboarding-credit-bonus":
    "{0} onboarding credits have been added, keep up the good work!",
  "notification-payment-deduction-failed-portal":
    "Failed to process card payment #{0}",
  notification_read_less: "Read less",
  notification_read_more: "Read more",
  notification_column_name_content: "Notifications",
  notification_column_name_date: "Received On",
  notification_view_all: "View All",
  settings_notification_title: "Notifications",
  settings_notification_desc:
    "Stay updated with the latest alerts and important updates—never miss a critical message or system change. Check your notifications now to ensure you're always in the loop.",

  "monitor-delivery-failed": "Delivery failed for Monitor: {0}.",
  "monitor-deactivated":
    "{name}: Deactivated after 0 failures | {name}: Deactivated after 1 failure | {name}: Deactivated after {number} failures",
  "remaining-credit-balance-low":
    "Your balance has reached zero. Refill your credits to keep everything running smoothly.",
};

export const notificationSimplify = {
  "notification-view-details": "查看详情",
  "none-notification-title": "暂无消息",
  "none-notification-description": "暂时没有消息，请稍后查看。",
  "notification-data-redemption-completed-people-message": `共使用 {0} 个积分兑换了 {1} 个联络人。`,
  "notification-services-status-update-message": `服务请求状态更改为 {0}`,
  "notification-receive-referral-credit-bonus-message":
    "已获得 {0} 推荐积分，请继续努力！",
  "notification-receive-onboarding-credit-bonus":
    "已获得 {0} 个入门积分，请继续努力！",
  "notification-payment-deduction-failed-portal": "无法处理卡片付款 #{0}",

  notification_read_less: "收起",
  notification_read_more: "展开",
  notification_column_name_content: "消息",
  notification_column_name_date: "接收时间",
  notification_view_all: "查看全部",
  settings_notification_title: "通知",
  settings_notification_desc:
    "随时了解最新警报和重要更新——绝不错过任何关键信息或系统变更。立即查看通知，确保您始终掌握最新动态。",
  "monitor-delivery-failed": "监控器投递失败：{0}。",
  "monitor-deactivated":
    "{name}：在 0 次失败后已停用 | {name}：在 1 次失败后已停用 | {name}：在 {number} 次失败后已停用",
  "remaining-credit-balance-low":
    "您的余额已归零。请及时充值积分，确保服务持续稳定运行。",
};

export const notificationTraditional = {
  "notification-view-details": "查看詳情",
  "none-notification-title": "暫無消息",
  "none-notification-description": "暫時沒有消息，請稍候查看。",
  "notification-data-redemption-completed-people-message": `總共 {0} 個點數已用於兌換 {1} 個聯絡人。`,
  "notification-services-status-update-message": `服務請求狀態變更為 {0}`,
  "notification-receive-referral-credit-bonus-message":
    "已新增 {0} 推薦點數，請繼續努力！",
  "notification-receive-onboarding-credit-bonus":
    "已新增 {0} 個入門點數，請繼續努力！",
  notification_read_less: "收起",
  notification_read_more: "展開",
  notification_column_name_content: "消息",
  notification_column_name_date: "接收時間",
  notification_view_all: "查看全部",
  "notification-payment-deduction-failed-portal": "無法處理卡片付款 #{0}",
  settings_notification_title: "通知",
  settings_notification_desc:
    "隨時掌握最新警報與重要更新——不錯過任何關鍵訊息或系統變更。立即查看您的通知，確保您時刻保持消息靈通。",
  "monitor-delivery-failed": "監察器傳送失敗：{0}。",
  "monitor-deactivated":
    "{name}：在 0 次失敗後已停用 | {name}：在 1 次失敗後已停用 | {name}：在 {number} 次失敗後已停用",
  "remaining-credit-balance-low":
    "您的餘額已歸零。請儘快充值點數，以確保服務持續穩定運行。",
};

export const notificationJapanese = {
  "notification-view-details": "詳細を見る",
  "none-notification-title": "通知はありません",
  "none-notification-description":
    "現在、通知はありません。後ほど確認してください。",
  "notification-data-redemption-completed-people-message": `合計 {0} ポイントが {1} 件の連絡先に対して使用されました。`,
  "notification-services-status-update-message": `サービスリクエストのステータスが {0} に更新されました`,
  "notification-receive-referral-credit-bonus-message":
    "紹介クレジット {0} が追加されました。引き続きお願いします！",
  "notification-receive-onboarding-credit-bonus":
    "オンボーディングクレジット {0} が追加されました。引き続きお願いします！",
  notification_read_less: "折りたたむ",
  notification_read_more: "展開する",
  notification_column_name_content: "メッセージ",
  notification_column_name_date: "受信日時",
  notification_view_all: "すべて表示",
  "notification-payment-deduction-failed-portal":
    "カード決済 #{0} を処理できませんでした",
  settings_notification_title: "通知",
  settings_notification_desc:
    "最新のアラートと重要な更新を常に把握しましょう——重要なメッセージやシステム変更を見逃すことはありません。通知を確認して、常に情報を得られる状態にしましょう。",
  "monitor-delivery-failed": "モニターの配信に失敗しました: {0}。",
  "monitor-deactivated":
    "{name}: 失敗 0 回で無効化されました | {name}: 失敗 1 回で無効化されました | {name}: 失敗 {number} 回で無効化されました",
  "remaining-credit-balance-low":
    "残高が 0 になりました。サービスを安定稼働させるため、クレジットを補充してください。",
};

export const notificationKorean = {
  "notification-view-details": "상세 보기",
  "none-notification-title": "알림 없음",
  "none-notification-description":
    "현재 알림이 없습니다. 잠시 후 다시 확인해 주세요.",
  "notification-data-redemption-completed-people-message": `총 {0} 포인트가 {1}명의 연락처에 사용되었습니다.`,
  "notification-services-status-update-message": `서비스 요청 상태가 {0}(으)로 변경되었습니다`,
  "notification-receive-referral-credit-bonus-message":
    "추천 크레딧 {0}이 추가되었습니다. 계속해서 노력해 주세요!",
  "notification-receive-onboarding-credit-bonus":
    "온보딩 크레딧 {0}이 추가되었습니다. 계속해서 노력해 주세요!",
  notification_read_less: "접기",
  notification_read_more: "펼치기",
  notification_column_name_content: "메시지",
  notification_column_name_date: "수신 시간",
  notification_view_all: "모두 보기",
  "notification-payment-deduction-failed-portal":
    "카드 결제 #{0}을(를) 처리할 수 없습니다",
  settings_notification_title: "알림",
  settings_notification_desc:
    "최신 경고 및 중요한 업데이트를 놓치지 마세요——중요한 메시지나 시스템 변경 사항을 확인할 수 있습니다. 알림을 확인하여 항상 정보를 얻을 수 있도록 하세요.",
  "monitor-delivery-failed": "모니터 전송 실패: {0}.",
  "monitor-deactivated":
    "{name}: 실패 0회 후 비활성화됨 | {name}: 실패 1회 후 비활성화됨 | {name}: 실패 {number}회 후 비활성화됨",
  "remaining-credit-balance-low":
    "잔액이 0이 되었습니다. 서비스가 안정적으로 계속 실행되도록 크레딧을 충전해 주세요.",
};

export const notificationHindi = {
  "notification-view-details": "विवरण देखें",
  "none-notification-title": "कोई सूचना नहीं",
  "none-notification-description":
    "अभी कोई सूचना नहीं है, कृपया बाद में जांचें।",
  "notification-data-redemption-completed-people-message": `कुल {0} पॉइंट {1} संपर्कों पर रिडीम किए गए।`,
  "notification-services-status-update-message": `सेवा अनुरोध की स्थिति {0} में बदल गई है`,
  "notification-receive-referral-credit-bonus-message":
    "{0} रेफरल क्रेडिट जोड़े गए हैं, कृपया प्रयास जारी रखें!",
  "notification-receive-onboarding-credit-bonus":
    "{0} ऑनबोर्डिंग क्रेडिट जोड़े गए हैं, कृपया प्रयास जारी रखें!",
  notification_read_less: "कम देखें",
  notification_read_more: "अधिक देखें",
  notification_column_name_content: "संदेश",
  notification_column_name_date: "प्राप्ति समय",
  notification_view_all: "सभी देखें",
  "notification-payment-deduction-failed-portal":
    "कार्ड भुगतान #{0} को संसाधित नहीं कर सका",
  settings_notification_title: "सूचनाएं",
  settings_notification_desc:
    "नवीनतम अलर्ट और महत्वपूर्ण अपडेट के साथ अपडेट रहें——कोई भी महत्वपूर्ण संदेश या सिस्टम परिवर्तन न चूकें। अपनी सूचनाएं देखकर सुनिश्चित करें कि आप हमेशा सूचित रहें।",
  "monitor-delivery-failed": "मॉनिटर के लिए डिलीवरी विफल: {0}।",
  "monitor-deactivated":
    "{name}: 0 विफलताओं के बाद निष्क्रिय किया गया | {name}: 1 विफलता के बाद निष्क्रिय किया गया | {name}: {number} विफलताओं के बाद निष्क्रिय किया गया",
  "remaining-credit-balance-low":
    "आपका बैलेंस शून्य हो गया है। सेवाओं को निर्बाध और स्थिर रूप से चलाते रहने के लिए कृपया क्रेडिट रीचार्ज करें।",
};
